/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum FuelSurchargeSource {
  CarrierSpecific = "CARRIER_SPECIFIC",
  Fca = "FCA",
}

export function instanceOfFuelSurchargeSource(value: any): boolean {
  for (const key in FuelSurchargeSource) {
    if (Object.prototype.hasOwnProperty.call(FuelSurchargeSource, key)) {
      if (
        FuelSurchargeSource[key as keyof typeof FuelSurchargeSource] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function FuelSurchargeSourceFromJSON(json: any): FuelSurchargeSource {
  return FuelSurchargeSourceFromJSONTyped(json, false);
}

export function FuelSurchargeSourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FuelSurchargeSource {
  return json as FuelSurchargeSource;
}

export function FuelSurchargeSourceToJSON(
  value?: FuelSurchargeSource | null,
): any {
  return value as any;
}

export function FuelSurchargeSourceToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): FuelSurchargeSource {
  return value as FuelSurchargeSource;
}
